import {isValueConsideredAsEmpty} from './lang';

export class QueryParamBuilder {

  constructor(public root: string) {
    this.root = root;
  }

  /*
   The order is important
   */
  public add(param: string, value: string | boolean | number, condition: boolean = true): QueryParamBuilder {
    if (condition) {
      this.concat(param, value);
    }
    return this;
  }

  /*
   The order is important
   */
  public addIfNotNull(param: string, value: string | boolean | number, condition: boolean = true): QueryParamBuilder {
    if (condition && !isValueConsideredAsEmpty(value)) {
      this.concat(param, value);
    }
    return this;
  }

  public build(): string {
    return this.root;
  }

  private concat(param: string, value: string | boolean | number): void {
    const separator = this.root.includes('?') ? `&` : '?';
    this.root += `${separator}${param}=${value}`;
  }

}

